import {UserGroup} from '@nursio-link/common';

export const isEmployeesGroupAllowedToUpdateStock = (
  allowedGroups?: UserGroup[]
) => allowedGroups?.includes(UserGroup.Employees) || false;

export const normalizeItemName = (name: string) => name.trim().toLowerCase();
